// Уход со страницы «назад» — канонический дом для формы, размноженной по проекту
// копипастой (32 компонента, 12 вариантов; этот — доминирующий, 16 копий).
//
// Повод завести миксин: Investors.vue, InvestorsArchive.vue и Tariffs.vue звали
// this.goBack() в ветке ролевого отказа, НЕ имея самого метода. Роутер эти маршруты
// по ролям не гардит (src/router/index.js: только requiresAuth/requiresStaff/
// requiresCrm), то есть проверка в created() и была гардом — а падала на TypeError
// раньше, чем успевала показать $notify: не пущенного пользователя не уводило и
// причины он не видел. Три новых копии метода эту дыру закрыли бы, но и умножили;
// поэтому — один дом, как у catImageMixin/clientCardLinkMixin.
//
// Остальные 32 копии намеренно НЕ тронуты: каждая живёт в своём контексте, их перевод
// сюда — отдельная работа с отдельной проверкой. Новый код берёт этот миксин.
//
// Ветку `PageData.backCrumb` из доминирующей формы НЕ переносим: `PageData` читают 30
// файлов и не объявляет НИ ОДИН — ни data, ни props, ни provide/inject, ни Vue.mixin.
// Условие всегда ложно, то есть все 32 копии и так уходят на дашборд. Переносить мёртвую
// ветку в новый общий дом значило бы узаконить её ещё на три страницы.
export default {
  methods: {
    goBack() {
      // history.length > 2 — «пришли по навигации внутри приложения»: назад безопасно.
      // Иначе (прямой заход по ссылке / первый экран) назад некуда — уводим на дашборд.
      if (window.history.length > 2) {
        this.$router.go(-1);
        return;
      }
      // .catch(): vue-router 3 отдаёт NavigationDuplicated реджектом, если уже здесь.
      this.$router.push({ path: "/dashboard" }).catch(() => {});
    },
  },
};
